import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AppState } from '@cemex/cmx-client-layout';
import { Store } from '@ngrx/store';
import { filter, take, takeWhile, withLatestFrom } from 'rxjs/operators';
// import ShipmentLocationActions from '../redux/actions/shipment-location.actions';
import {
  selectActiveLegalEntityAndActiveProductType,
  selectActiveLegalEntityAndProductTypeState,
} from '../redux/selectors/multiple-order-online.selector';
import { selectActiveProductTypeId, selectProductTypeState } from '../redux/selectors/product-type.selector';
// import {
//   selectActiveShipmentLocationId,
//   selectShipmentLocationState,
// } from '../redux/selectors/shipment-location.selector';
import ProductTypeActions from './../redux/actions/product-type.actions';
import SalesRegionsActions from './../redux/actions/sales-regions.actions';
import ShipmentLocationActions from './../redux/actions/shipment-location.actions';
import ShippingConditionActions from '../redux/actions/shipping-condition.actions';
import {
  selectActiveShippingConditionId,
  selectShippingConditionState,
} from '../redux/selectors/shipping-condition.selector';
import { ProductTypeIdEnum } from '@ordersnproducts/modules/shared/constants/product-type.enum';

@Injectable()
// {
//     providedIn: 'root',
// }
export class MooResolverService implements Resolve<void> {
  constructor(private store: Store<AppState>) {}

  resolve(): void {
    this.store.dispatch(ProductTypeActions.resetProductTypeState());
    this.store.dispatch(SalesRegionsActions.resetSalesRegionsState());
    this.store.dispatch(ShipmentLocationActions.resetShipmentLocationState());
    this.store.dispatch(ShippingConditionActions.resetShippingConditionState());
    // business lines
    const businessLines$ = this.store.select(selectActiveLegalEntityAndProductTypeState).pipe(
      takeWhile(({ productTypeState }) => !productTypeState.isFetched),
      filter(({ activeLegalEntity }) => !!activeLegalEntity),
      take(1),
    );
    businessLines$.subscribe(() => {
      this.store.dispatch(ProductTypeActions.fetch());
    });
    const activeBusinessLine$ = this.store.select(selectProductTypeState).pipe(
      filter(({ isFetched }) => !!isFetched),
      withLatestFrom(this.store.select(selectActiveProductTypeId)),
      takeWhile(([_, id]) => !id),
      take(1),
    );
    activeBusinessLine$.subscribe(([{ payload }]) => {
      this.store.dispatch(ProductTypeActions.setActive({ productTypeId: this.selectActiveEntity(payload.ids) }));
    });
    // shipping conditions
    const shippingConditions$ = this.store.select(selectActiveLegalEntityAndActiveProductType).pipe(
      filter(({ activeLegalEntity, activeProductType }) => !!activeLegalEntity && !!activeProductType),
      withLatestFrom(this.store.select(selectShippingConditionState)),
      takeWhile(([_, { isFetched }]) => !isFetched),
      take(1),
    );
    shippingConditions$.subscribe(() => {
      this.store.dispatch(ShippingConditionActions.fetch());
    });
    const activeShippingCondition$ = this.store.select(selectShippingConditionState).pipe(
      filter(({ isFetched }) => !!isFetched),
      withLatestFrom(this.store.select(selectActiveShippingConditionId)),
      takeWhile(([_, id]) => !id),
      take(1),
    );
    activeShippingCondition$.subscribe(([{ payload }]) => {
      if (payload.ids.length === 1) {
        this.store.dispatch(ShippingConditionActions.setActive({ shippingConditionId: payload.ids[0] }));
      }
    });
    // this.store
    //   .select(selectActiveLegalEntityAndActiveProductType)
    //   .pipe(
    //     filter(({ activeLegalEntity, activeProductType }) => !!activeLegalEntity && !!activeProductType),
    //     withLatestFrom(this.store.select(selectShipmentLocationState)),
    //     takeWhile(([_, { isFetched }]) => !isFetched),
    //     take(1),
    //   )
    //   .subscribe(() => {
    //   });
    // this.store
    //   .select(selectShipmentLocationState)
    //   .pipe(
    //     filter(({ isFetched, isLoading }) => isFetched && !isLoading),
    //     withLatestFrom(this.store.select(selectActiveShipmentLocationId)),
    //     takeWhile(([_, id]) => !id),
    //     take(1),
    //   )
    //   .subscribe(([{ payload }]) => {
    //     this.setActiveAndSelectedShipmentLocation(payload.ids[0]);
    //   });
  }

  /**
   * Selects the active product line from a list of product IDs.
   * Prioritizes the "ReadyMix" product if present; otherwise, returns the first product ID.
   * @param {string[] | number[]} productsId - An array of product IDs.
   * @returns {number} The selected product ID.
   */
  private selectActiveEntity(productsId: string[] | number[]): number {
    const productsIds = (productsId as (string | number)[]).map((id) => id.toString());
    const defaultEntity = productsIds.includes(ProductTypeIdEnum.ReadyMix) ? ProductTypeIdEnum.ReadyMix : productsId[0];
    return Number(defaultEntity);
  }

  // private setActiveAndSelectedShipmentLocation(shipmentLocationId: string | number, reset?: boolean) {
  //   if (reset) {
  //     this.store.dispatch(ShipmentLocationActions.resetSelected());
  //   }
  //   this.store.dispatch(ShipmentLocationActions.addSelected({ shipmentLocationId }));
  //   this.store.dispatch(ShipmentLocationActions.setActive({ shipmentLocationId }));
  // }
}
